"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LEAVE_OSCE_MARKSHEET = exports.optimisticEndOsceMarksheet = exports.updateCacheOnEndOsceMarksheet = exports.END_OSCE_MARKSHEET = exports.MODIFY_OSCE_MARKSHEET = exports.SAVE_OSCE_MARKSHEET = exports.PRESTART_OSCE_MARKSHEET = exports.START_OSCE_TIMER = exports.START_OSCE_MARKSHEET = exports.SELECT_OSCE_STATION = exports.optimisticMarkOsceMarksheetMark = exports.MARK_OSCE_MARKSHEET_MARK = exports.CHANGE_OSCE_ROLE = exports.BUILD_OSCE_MARKSHEET = exports.CREATE_OR_JOIN_OSCE_MARKSHEET = exports.CANCEL_OSCE_MATCHMAKING = exports.CHECK_OSCE_MATCHMAKING = exports.ACCEPT_OSCE_MATCHMAKING = exports.START_OSCE_MATCHMAKING = void 0;
const client_1 = require("@apollo/client");
const models_1 = require("../../../models");
const fragments_1 = require("../../fragments");
exports.START_OSCE_MATCHMAKING = (0, client_1.gql) `
  mutation StartOsceMatchmaking($sessionId: String!) {
    restricted {
      startOsceMatchmaking(sessionId: $sessionId)
    }
  }
`;
exports.ACCEPT_OSCE_MATCHMAKING = (0, client_1.gql) `
  mutation AcceptOsceMatchmaking($sessionId: String!) {
    restricted {
      acceptOsceMatchmaking(sessionId: $sessionId)
    }
  }
`;
exports.CHECK_OSCE_MATCHMAKING = (0, client_1.gql) `
  ${fragments_1.OSCE_MATCHMAKING_ACTION_FIELDS}
  mutation CheckOsceMatchmaking {
    restricted {
      checkOsceMatchmaking {
        ...OsceMatchmakingActionFields
      }
    }
  }
`;
exports.CANCEL_OSCE_MATCHMAKING = (0, client_1.gql) `
  mutation CancelOsceMatchmaking($sessionId: String!) {
    restricted {
      cancelOsceMatchmaking(sessionId: $sessionId)
    }
  }
`;
exports.CREATE_OR_JOIN_OSCE_MARKSHEET = (0, client_1.gql) `
  ${fragments_1.OSCE_STATION_FIELDS}
  ${fragments_1.OSCE_MARKSHEET_FIELDS}
  mutation CreateOrJoinOsceMarksheet($sessionId: String!, $action: Int!) {
    restricted {
      createOrJoinOsceMarksheet(sessionId: $sessionId, action: $action) {
        ...OsceMarksheetFields
        osceStation {
          ...OsceStationFields
        }
      }
    }
  }
`;
exports.BUILD_OSCE_MARKSHEET = (0, client_1.gql) `
  ${fragments_1.OSCE_STATION_FIELDS}
  ${fragments_1.OSCE_MARKSHEET_FIELDS}
  mutation BuildOsceMarksheet(
    $osceStationId: Int!
    $osceMarksheetId: Int
    $entitlementId: Int
  ) {
    restricted {
      buildOsceMarksheet(
        osceStationId: $osceStationId
        osceMarksheetId: $osceMarksheetId
        entitlementId: $entitlementId
      ) {
        ...OsceMarksheetFields
        osceStation {
          ...OsceStationFields
        }
      }
    }
  }
`;
exports.CHANGE_OSCE_ROLE = (0, client_1.gql) `
  ${fragments_1.OSCE_MARKSHEET_FIELDS}
  mutation ChangeOsceRole($sessionId: String!, $role: Int!) {
    restricted {
      changeOsceRole(sessionId: $sessionId, role: $role) {
        ...OsceMarksheetFields
      }
    }
  }
`;
exports.MARK_OSCE_MARKSHEET_MARK = (0, client_1.gql) `
  mutation MarkOsceMarksheetMark($osceMarksheetMarkId: Int!, $mark: Int!) {
    restricted {
      markOsceMarksheetMark(
        osceMarksheetMarkId: $osceMarksheetMarkId
        mark: $mark
      ) {
        id
        selectedChoice
        mark
      }
    }
  }
`;
const optimisticMarkOsceMarksheetMark = (variables, productType) => {
    const data = {};
    if (productType === models_1.EProductType.PACES) {
        data.selectedChoice = variables.mark;
        data.mark = null;
    }
    else {
        data.mark = variables.mark;
        data.selectedChoice = null;
    }
    return {
        restricted: {
            markOsceMarksheetMark: {
                ...data,
                id: variables.osceMarksheetMarkId,
                __typename: 'OsceMarksheetMark',
            },
        },
    };
};
exports.optimisticMarkOsceMarksheetMark = optimisticMarkOsceMarksheetMark;
exports.SELECT_OSCE_STATION = (0, client_1.gql) `
  ${fragments_1.OSCE_STATION_FIELDS}
  ${fragments_1.OSCE_MARKSHEET_FIELDS}
  mutation SelectOsceMarksheetStation(
    $osceMarksheetId: Int!
    $osceStationId: Int!
  ) {
    restricted {
      selectOsceMarksheetStation(
        osceMarksheetId: $osceMarksheetId
        osceStationId: $osceStationId
      ) {
        ...OsceMarksheetFields
        osceStation {
          ...OsceStationFields
        }
      }
    }
  }
`;
exports.START_OSCE_MARKSHEET = (0, client_1.gql) `
  ${fragments_1.OSCE_STATION_FIELDS}
  ${fragments_1.OSCE_MARKSHEET_FIELDS}
  mutation StartOsceMarksheet($osceMarksheetId: Int!) {
    restricted {
      startOsceMarksheet(osceMarksheetId: $osceMarksheetId) {
        ...OsceMarksheetFields
        osceStation {
          ...OsceStationFields
        }
      }
    }
  }
`;
exports.START_OSCE_TIMER = (0, client_1.gql) `
  mutation StartOsceTimer($osceMarksheetId: Int!) {
    restricted {
      startOsceTimer(osceMarksheetId: $osceMarksheetId) {
        id
        startedAt
        endedAt
        timeRemaining
        totalStationTime
        stage
        state
      }
    }
  }
`;
exports.PRESTART_OSCE_MARKSHEET = (0, client_1.gql) `
  ${fragments_1.OSCE_STATION_FIELDS}
  ${fragments_1.OSCE_MARKSHEET_FIELDS}
  mutation PrestartOsceMarksheet(
    $osceMarksheetId: Int!
    $readingTime: Int!
    $stationTime: Int!
    $feedbackTime: Int!
    $isTimed: Boolean
  ) {
    restricted {
      prestartOsceMarksheet(
        osceMarksheetId: $osceMarksheetId
        readingTime: $readingTime
        stationTime: $stationTime
        feedbackTime: $feedbackTime
        isTimed: $isTimed
      ) {
        ...OsceMarksheetFields
        osceStation {
          ...OsceStationFields
        }
      }
    }
  }
`;
exports.SAVE_OSCE_MARKSHEET = (0, client_1.gql) `
  ${fragments_1.OSCE_MARKSHEET_FIELDS}
  mutation SaveOsceMarksheet(
    $osceMarksheetId: Int!
    $feedback: String
    $globalScore: Int
  ) {
    restricted {
      saveOsceMarksheet(
        osceMarksheetId: $osceMarksheetId
        feedback: $feedback
        globalScore: $globalScore
      ) {
        id
        feedback
        globalScore
      }
    }
  }
`;
exports.MODIFY_OSCE_MARKSHEET = (0, client_1.gql) `
  mutation ModifyOsceMarksheet($input: ModifyOsceMarksheetInput) {
    restricted {
      modifyOsceMarksheet(input: $input) {
        id
        state
        startedAt
        pausedAt
        endedAt
      }
    }
  }
`;
exports.END_OSCE_MARKSHEET = (0, client_1.gql) `
  ${fragments_1.OSCE_MARKSHEET_FIELDS}
  mutation EndOsceMarksheet(
    $osceMarksheetId: Int!
    $feedback: String
    $globalScore: Int
  ) {
    restricted {
      endOsceMarksheet(
        osceMarksheetId: $osceMarksheetId
        feedback: $feedback
        globalScore: $globalScore
      ) {
        ...OsceMarksheetFields
      }
    }
  }
`;
const updateCacheOnEndOsceMarksheet = (productType) => (cache, result, options) => {
    const { endOsceMarksheet } = result?.data?.restricted || {};
    const { variables } = options || {};
    if (!variables || !endOsceMarksheet) {
        return;
    }
    cache.writeFragment({
        id: cache.identify({
            id: endOsceMarksheet.id,
            __typename: 'OsceMarksheet',
        }),
        data: {
            completed: true,
            score: endOsceMarksheet.score,
            state: endOsceMarksheet.state,
            globalScore: endOsceMarksheet.globalScore,
            timeTaken: endOsceMarksheet.timeTaken,
            endedAt: endOsceMarksheet.endedAt,
        },
        fragment: fragments_1.COMPLETED_OSCE_MARKSHEET_FRAGMENT,
    });
    cache.writeFragment({
        id: cache.identify({
            id: endOsceMarksheet.osceStationId,
            __typename: 'OsceStation',
        }),
        data: {
            completedMarks: endOsceMarksheet.marks.filter((m) => productType === models_1.EProductType.OSCE
                ? m.mark !== null
                : m.selectedChoice !== null).length,
            score: endOsceMarksheet.score,
            lastOsceMarksheetId: endOsceMarksheet.id,
        },
        fragment: fragments_1.COMPLETED_OSCE_STATION_FRAGMENT,
    });
};
exports.updateCacheOnEndOsceMarksheet = updateCacheOnEndOsceMarksheet;
const optimisticEndOsceMarksheet = (marksheet) => ({
    restricted: {
        __typename: 'RestrictedMutation',
        endOsceMarksheet: {
            __typename: 'OsceMarksheet',
            ...marksheet,
            completed: true,
        },
    },
});
exports.optimisticEndOsceMarksheet = optimisticEndOsceMarksheet;
exports.LEAVE_OSCE_MARKSHEET = (0, client_1.gql) `
  ${fragments_1.OSCE_MARKSHEET_FIELDS}
  mutation LeaveOsceMarksheet($osceMarksheetId: Int!) {
    restricted {
      leaveOsceMarksheet(osceMarksheetId: $osceMarksheetId) {
        ...OsceMarksheetFields
      }
    }
  }
`;
